import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './HomeChallengesPreview.scss';

// import images
import download from "../../assets/Images/Challenges/download.svg"
import main from "../../assets/Images/Challenges/main.png"
import cluster from "../../assets/Images/Challenges/cluster.svg"

const TABS_DATA = [
  'Healthcare',
  'eCommerce',
  'Automotive App',
  'Logistics',
  'Automotive Web',
];

const CASE_STUDIES_DATA = [
  {
    id: 0,
    category: 'HEALTHCARE',
    description: 'Developed a HIPAA-compliant digital health platform enabling secure patient management, teleconsultation, and real-time clinical data integration across multi-location healthcare networks.',
    stats: [
      { value: '50K+', label: 'Active Patients Managed' },
      { value: '10K+', label: 'Monthly Teleconsultations' }
    ],
    imageAlt: 'Tablet showing X-ray scans',
    image: main,
  },
  {
    id: 1,
    category: 'ECOMMERCE',
    description: 'Engineered a highly scalable omnichannel retail platform capable of processing thousands of concurrent transactions with sub-second latency and AI-driven recommendations.',
    stats: [
      { value: '2M+', label: 'Monthly Active Users' },
      { value: '45%', label: 'Increase in Conversions' }
    ],
    imageAlt: 'eCommerce dashboard',
    image: main,
  },
  {
    id: 2,
    category: 'AUTOMOTIVE APP',
    description: 'Built a comprehensive fleet management and telemetry web app for real-time vehicle tracking, predictive maintenance alerts, and advanced driver behavior analytics.',
    stats: [
      { value: '100K+', label: 'Connected Vehicles' },
      { value: '30%', label: 'Reduction in Downtime' }
    ],
    imageAlt: 'Fleet management dashboard on a laptop',
    image: main,
  },
  {
    id: 3,
    category: 'LOGISTICS',
    description: 'Delivered an AI-powered supply chain optimization platform featuring dynamic route planning, automated warehouse inventory tracking, and predictive delay modeling.',
    stats: [
      { value: '$5M+', label: 'Annual Cost Savings' },
      { value: '99.9%', label: 'Tracking Accuracy' }
    ],
    imageAlt: 'Logistics routing map and analytics',
    image: main,
  },
  {
    id: 4,
    category: 'AUTOMOTIVE WEB',
    description: 'Designed and developed an immersive, WebGL-powered 3D car configurator and dealership portal, resulting in enhanced user engagement and streamlined lead generation.',
    stats: [
      { value: '3X', label: 'Increase in Test Drives' },
      { value: '1.2s', label: 'Average Load Time' }
    ],
    imageAlt: '3D car configurator on a website',
    image: main,
  }
];
function HomeChallengesPreview() {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const currentData = CASE_STUDIES_DATA[activeTab] || CASE_STUDIES_DATA[0];

  return (
    <section className="case-studies-section">
      {/* Background Glow */}
      <div className="cs-bg-glow" aria-hidden="true"></div>

      <div className="cs-container">

        {/* Header Section */}
        <div className="cs-header">
          <div className="cs-capsule">
            <div className="icon-wrapper">
              <div className="icon-blur" aria-hidden="true"></div>
              {/* Keep src empty as requested */}
              <img src={cluster} alt="cluster" className="cs-icon" />
            </div>
            <span>Case Studies</span>
          </div>

          <h2 className="cs-heading">
            <span className="text-white">Solving Real-World</span>
            <br />
            <span className="highlight-box">Challenges With Smart Tech</span>
          </h2>
        </div>

        {/* Interactive Case Studies Area */}
        <div className="cs-interactive-area">

          {/* Tabs */}
          <div className="cs-tabs-header">
            {TABS_DATA.map((tab, index) => (
              <button
                key={index}
                className={`cs-tab-btn ${activeTab === index ? 'active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Content Card with Framer Motion */}
          <div className="cs-content-card">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                className="cs-card-inner"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >

                {/* Left Side: Text & Data */}
                <div className="cs-card-content">
                  <div className="cs-text-group">
                    <h3 className="cs-category">{currentData.category}</h3>
                    <p className="cs-description">{currentData.description}</p>
                  </div>

                  <div className="cs-stats-row">
                    {currentData.stats.map((stat, idx) => (
                      <div className="cs-stat-item" key={idx}>
                        <h4>{stat.value}</h4>
                        <p>{stat.label}</p>
                      </div>
                    ))}
                  </div>

                  <div className="cs-actions">
                    <button className="cs-btn-primary" onClick={() => navigate('/case-studies')}>
                      View Case Study
                    </button>
                    <button className="cs-btn-secondary" onClick={() => navigate('/case-studies')}>
                      {/* Empty src for download icon */}
                      <img src={download} alt="download" className="btn-icon" />
                      Download Case Study
                    </button>
                  </div>
                </div>

                {/* Right Side: Image */}
                <div className="cs-card-image-wrapper">
                  <img src={currentData.image} alt={currentData.imageAlt} className="cs-feature-image" />
                </div>

              </motion.div>
            </AnimatePresence>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HomeChallengesPreview;